<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/pOLz0e/tc-custom/9781504022705.jpg?1720122370788" alt="This image is the cover for the book Mad Chopper"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Mad Chopper
      </h1>
      <p class="bookDescription body article font2">
        <b>The author of the true crime “masterpiece” <i>Lobster Boy</i> traces a brutal killer’s history across two decades of slipping past the legal system (<i>The Guardian</i>).</b><br/><br/> When police in Tampa, Florida, arrested Larry Singleton in 1997 for brutally murdering prostitute Roxanne Hayes, they soon realized it wasn’t the man’s first violent attack. Back in 1978 he had gained notoriety as “the Mad Chopper” for raping and cutting off the arms of 15-year-old Mary Vincent on a patch of desolate, sun-scorched land 5 miles off the highway near Modesto, California.<br/>  <br/> When Singleton was let out of prison on supervised parole after serving only 8 years for his crimes, no community in California would accept him. He eventually moved back to his home in Florida, where he killed Hayes nearly 20 years after his original crime. But his first victim, Vincent, had survived, walking nearly a mile to get help after the assault, and testified against him at his trial for murdering Hayes.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Fred Rosen
      </h2>
      
      <p class="authorDescription body article">Fred Rosen, a former columnist for the Arts &amp; Leisure section of the<I> New York Times</I>, is an award-winning author of true crime and history books, including<I> Gold!</I>, <I>Did They Really Do It?</I>, and <I>Lobster Boy. </I>He can frequently be seen on the Investigation Discovery network&rsquo;s <I>Evil Kin</I> and <I>Evil Twins</I> TV series, where he is a regular on-air commentator.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5cb8aa2c